import { render, staticRenderFns } from "./MenuAddBasicInfo.vue?vue&type=template&id=4dc03547&lang=html&"
import script from "./MenuAddBasicInfo.vue?vue&type=script&lang=js&"
export * from "./MenuAddBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports